import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner, Alert, Container } from 'react-bootstrap';

import { useAuth } from '../context/AuthContext';

interface AdminRouteProps {
  children: React.ReactElement;
}

/**
 * Wrapper de rota para poderes operacionais de admin (ADMIN ou GERENTE).
 * Gestão de usuários continua só no backend com require_full_admin + menu Usuários.
 */
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="loading-spinner">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Carregando...</span>
        </Spinner>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== 'admin' && user?.role !== 'gerente') {
    return (
      <Container className="py-4">
        <Alert variant="warning" className="d-flex align-items-start">
          <i className="bi bi-shield-exclamation fs-3 me-3" aria-hidden="true"></i>
          <div>
            <Alert.Heading className="h5 mb-2">Acesso restrito</Alert.Heading>
            <p className="mb-0">
              Esta área é exclusiva para administradores e gerentes. Caso acredite que precisa
              de acesso, fale com um administrador.
            </p>
          </div>
        </Alert>
      </Container>
    );
  }

  return children;
};

export default AdminRoute;
